export const optionsToStrategy = (options: {label: string | JSX.Element, value: string | number}[]) => {
  return options.reduce((acc, {label, value}) => {
    return {
      ...acc, 
      [value]: label
    }
  }, {})
}